 const Edit = () => {
    return <div>edit</div>;
};

export default Edit;